export default __webpack_public_path__ + "static/media/drink.723fa963.svg";